export const quarterList = [
  { label: "Quarter 1", value: 1 },
  { label: "Quarter 2", value: 2 },
  { label: "Quarter 3", value: 3 },
  { label: "Quarter 4", value: 4 },
  { label: "Annual", value: 5 }
]

export const yearList = [
  { label: "2021", value: 2021 },
  { label: "2022", value: 2022 },
  { label: "2023", value: 2023 },
  { label: "2024", value: 2024 },
  { label: "2025", value: 2025 },
  { label: "2026", value: 2026 },
  { label: "2027", value: 2027 },
  { label: "2028", value: 2028 },
  { label: "2029", value: 2029 },
  { label: "2030", value: 2030 }
]

export const yearListNuberOnly = [
  2021, 2022, 2023, 2024, 2025, 2026, 2027, 2028, 2029, 2030
]
